class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.element = this;
    this.header = document.querySelector('.header-wrapper');
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
  }
  
  bindEvents() {
    this.delegateElement.on(
      "mouseenter",
      "[aria-hasMenu='true']",
      this.openMenu.bind(this),
      true
    );
  
    this.delegateElement.on(
      "focusin",
      "[aria-hasMenu='true']",
      this.openMenu.bind(this),
      true
    );
  
    this.delegateElement.on(
      "mouseleave",
      "[aria-hasMenu='true']",
      this.handleMouseLeave.bind(this),
      true
    );
  
    this.delegateElement.on(
      "mouseenter",
      ".mega-menu__content[aria-hidden='false']",
      this.cancelCloseMenu.bind(this),
      true
    );
  }
  
  openMenu(event, target, element) {
    const allDropdowns = document.querySelectorAll("[aria-hasMenu='true'][open]");
    allDropdowns.forEach((dropdown) => {
      if (dropdown !== target) {
        dropdown.removeAttribute('open');
        dropdown.querySelector('.mega-menu__content').setAttribute('aria-hidden', 'true');
      }
    });
  
    target.setAttribute('open', true);
    const menuContent = target.querySelector('.mega-menu__content');
    menuContent.setAttribute('aria-hidden', 'false');
  }
  
  handleMouseLeave(event) {
    const target = event.currentTarget;
  
    this.closeMenuTimeout = setTimeout(() => {
      if (!target.matches(':hover') && !target.querySelector(':hover')) {
        this.closeMenu(event, target);
      }
    }, 100);
  }
  
  cancelCloseMenu() {
    clearTimeout(this.closeMenuTimeout);
  }
  
  closeMenu(event, target) {
    const menuContent = target.querySelector('.mega-menu__content[aria-hidden="false"]');
    if (menuContent) {
      menuContent.setAttribute('aria-hidden', 'true');
      menuContent.parentElement.removeAttribute('open');
    }
    
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
